import React from "react";
import { array, string } from "prop-types";
import { Link } from "@quintype/components";

import "./footerMenuGroup.m.css";

const FooterMenuGroup = ({ links, className = "", language }) => (
  <div styleName={`wrapper ${language === "en" ? "en-wrappper" : ""}`} className={`footer-menu-group ${className}`}>
    {links.map((item, index) => (
      <Link href={item.completeUrl} key={index} styleName="footer-menu-item" className="footer-menu-item">
        {item.title}
      </Link>
    ))}
  </div>
);

FooterMenuGroup.propTypes = {
  links: array,
  className: string,
  language: string
};

export default FooterMenuGroup;
